import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
import { Reveal } from './ui/Reveal';
export function Bonuses() {
  return <section className="bg-cream px-4 pb-14 sm:px-5 sm:pb-24" data-id="element-28" data-mp="asz4oix6kk4k">
      <div className="mx-auto max-w-6xl" data-id="element-29" data-mp="ft4ppg8y38do">
        <Reveal data-id="element-30" data-mp="fs3ffdzr6px0">
          <SectionLabel data-id="element-31" data-mp="1ueuk65oriry">Inclusi senza costi aggiuntivi</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[26ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-32" data-mp="1t3r67g5kd1d">
            5 bonus per giovani inventori:{' '}
            <span className="text-orange" data-id="element-33" data-mp="3o2n2jujn9yhj">
              più facile iniziare, costruire insieme e restare motivati.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-34" data-mp="3t2j7bw061ty5">
            Cinque risorse extra che togliono gli attriti: cosa preparare, cosa
            fare quando il tempo è poco e come tenere vivo l’entusiasmo.
          </p>
        </Reveal>

        <ul className="rail mt-9 -mx-4 px-4 pb-2 sm:mx-0 sm:mt-12 sm:gap-4 sm:px-0 sm:pb-0 sm:grid-cols-2 lg:grid-cols-5" data-id="element-35" data-mp="3dflfrceod84l">
          {bonuses.map((bonus, index) => <li key={bonus.label} className="h-full" data-id="element-36" data-mp="3r68h7cbtlc4d" data-mpi={index}>
              <Reveal delay={index * 0.04} className="h-full" data-id="element-37" data-mp="3n4muz0deblhi">
                <article className="flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink/10 bg-white transition-[transform,box-shadow] duration-150 ease-snap hover:-translate-y-1 hover:shadow-card" data-id="element-38" data-mp="3n79bhpi9lbbv">
                  <p className="bg-orange px-4 py-2.5 text-[10px] font-black uppercase tracking-[0.16em] text-white" data-id="element-39" data-mp="38g8vmzf6uf5p">
                    {bonus.label}
                  </p>
                  <div className="flex flex-1 flex-col p-5" data-id="element-40" data-mp="33fumtf5rj16m">
                    <h3 className="text-base font-black leading-snug text-ink" data-id="element-41" data-mp="np004uox2gap">
                      {bonus.title}
                    </h3>
                    <p className="mt-2 text-[15px] font-semibold leading-relaxed text-ink/60 sm:text-sm" data-id="element-42" data-mp="it136ipivpyo">
                      {bonus.description}
                    </p>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>

        <div className="mt-7 flex flex-col items-center gap-4 sm:mt-9 sm:gap-5" data-id="element-43" data-mp="3lkw8zk7usrn5">
          <p className="flex w-fit items-center gap-2.5 rounded-full border-2 border-dashed border-orange/45 bg-orange/[0.06] px-5 py-2.5 text-center text-[10px] font-black uppercase leading-tight tracking-[0.12em] text-orange sm:px-6 sm:py-3 sm:text-[11px] sm:tracking-[0.14em]" data-id="element-44" data-mp="3qixpbxdwacux">
            <GiftIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-45" data-mp="32slby6zvrnwy" />
            5 risorse extra senza costi aggiuntivi
          </p>
          <CtaButton size="md" tone="moss" className="w-full text-center leading-tight sm:w-auto" data-id="element-46" data-mp="37klf08b8ywxr">
            Voglio i volumi + i 5 bonus
          </CtaButton>
        </div>
      </div>
    </section>;
}